module.exports = __webpack_public_path__ + "static/img/Download_on_the_App_Store.afb42dd.png";